package platform

import kotlinx.datetime.Instant
import kotlinx.datetime.toJSDate

actual fun instantToPlatform(instant: Instant): Any = instant.toJSDate()
